import { render, staticRenderFns } from "./NewVersion.vue?vue&type=template&id=6bfbc838&scoped=true&"
import script from "./NewVersion.vue?vue&type=script&lang=js&"
export * from "./NewVersion.vue?vue&type=script&lang=js&"
import style0 from "./NewVersion.vue?vue&type=style&index=0&id=6bfbc838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfbc838",
  null
  
)

export default component.exports